import { SubordinatedInBuComponent } from "./subordinates-in-bu.component";
export const SubordinatesInBuModule = angular
    .module('subordinatesInBu', [])
    .component(SubordinatedInBuComponent.selector, SubordinatedInBuComponent.component)
    .name;
//# sourceMappingURL=subordinates-in-bu.module.js.map